<template>
    <MasterTemplate 
        title="ข้อมูลกลุ่มผู้ใช้งาน" 
        :headers="headers" 
        :setData="setData"
        itemKey="groupId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-text-field label="รหัสกลุ่ม" maxlength="20" v-model="editedItem.groupCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="ชื่อกลุ่ม" maxlength="100" v-model="editedItem.groupName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-text-field label="รายละเอียด" maxlength="1000" v-model="editedItem.groupDesc"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listGroup, isExistGroupCode, insert, update, deleteGroup} from '@/api/master/group-api.js'

export default {
    name: 'Group',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสกลุ่มซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.groupCode': function(newVal, oldVal) {
            if (!this.editedItem.groupId) {
                this.editedItem.groupId = '-1';
            }
            if (newVal && this.editedItem.groupId) {
                isExistGroupCode(newVal, this.editedItem.groupId).then(response => {
                    this.isDup = response;
                }).catch(e => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'รหัสกลุ่ม', value: 'groupCode'},
            {text: 'ชื่อกลุ่ม', value: 'groupName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            groupId: '-1',
            groupCode: '',
            groupName: '',
            groupDesc: ''
        }
    }),
    methods: {
        listData() {
            return listGroup()
        },
        deleteData(item) {
            return deleteGroup(item.groupId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.groupName;
        },
        setData(item) {
            this.editedItem = item;
        }
    }
}
</script>
